export default "__VITE_ASSET__xIQFyKCc__"